/**
 * MediaPlayerModes.js
 * 
 * This utility provides consistent mode detection and configuration for different
 * media playback scenarios: audio+srt, srt-only, or neither.
 */

/**
 * Determines the media player mode based on available sources
 * @param {string|null} audioSrc - The audio source URL
 * @param {string|null} srtSrc - The SRT subtitles source URL
 * @returns {string} The detected mode ("audio+srt", "srt-only", "text-only")
 */
export const getMediaPlayerMode = (audioSrc, srtSrc) => {
    if (audioSrc && srtSrc) {
      return "audio+srt";
    } else if (!audioSrc && srtSrc) {
      return "srt-only";
    } else {
      return "text-only";
    }
  };
  
  /**
   * Gets the appropriate control configuration for the given mode
   * @param {string} mode - The player mode
   * @returns {Object} Configuration object for controls display and behavior
   */
  export const getControlsConfig = (mode) => {
    switch (mode) {
      case "audio+srt":
        return {
          showPlayPause: true,
          showRewind: true,
          showVolume: true,
          showSubtitles: true,
          showNavigation: true,
          defaultMuted: false
        };
      case "srt-only":
        return {
          showPlayPause: true,
          showRewind: true,
          showVolume: false,
          showSubtitles: true,
          showNavigation: true,
          defaultMuted: true
        };
      case "text-only":
      default:
        return {
          showPlayPause: false,
          showRewind: false,
          showVolume: false,
          showSubtitles: true,
          showNavigation: false,
          defaultMuted: true
        };
    }
  };
  
  export default {
    getMediaPlayerMode,
    getControlsConfig
  };